import * as angular from "angular";
import {IController, IQService} from "angular";
import {$accountFactory} from "../../../account/$account.factory";
import {PlanningRequestsService} from "../../services/planning-requests.service";

export class PlanningTemplatesSelect implements IController {

  selectedId: any;
  ngPlaceholder: string;
  onChange: Function;

  public loaded: any;
  public templates: any[];
  public selectedTemplate: any;
  public searchTerm: string;

  private currentSelectedTemplate: any;

  /* @ngInject */
  constructor(private $mdSelect, private $log, private $account: $accountFactory, private $q: IQService, private planningRequestsService: PlanningRequestsService) {
  }

  $onInit() {

    this.loaded = false;
    this.templates = [];
    this.selectedTemplate = undefined;
    this.searchTerm = '';

    if (this.selectedId) {
      this.planningRequestsService.getTemplate(this.selectedId)
        .then((template) => {
          this.templates = [template];
          this.selectedTemplate = template;
        })
        .catch((err) => {
          this.$log.error('Failed to get templates', err);
        });
    } else {
      this.templates = [];
      this.selectedTemplate = undefined;
    }
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
    if (onChangesObj.selectedId && !onChangesObj.selectedId.isFirstChange()) {
      this.loaded = false;
      this.$onInit();
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  onOpen() {
    this.currentSelectedTemplate = this.selectedTemplate;

    if (!this.loaded) {
      return this.planningRequestsService.getTemplates()
        .then((templates) => {
          this.loaded = true;
          this.templates = templates;
        })
        .catch((error) => {
          this.$log.error('Failed to find templates @planningTemplatesSelect@onOpen', error);
        });

    } else {
      return this.$q.when();
    }
  }

  onClose() {
    this.searchTerm = '';
    this.selectedTemplate = this.currentSelectedTemplate;
  }

  cancel() {
    this.$mdSelect.hide();
  }

  reset() {
    this.searchTerm = '';
    this.selectedTemplate = undefined
  }

  select() {
    this.currentSelectedTemplate = this.selectedTemplate;

    this.onChange({template: this.selectedTemplate});
    this.$mdSelect.hide();
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningTemplatesSelect', {
    bindings: {
      selectedId: '<',
      isRequired: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./planning-templates-select.html').default,
    controller: PlanningTemplatesSelect
  });

